import { Footer } from "../components/footer.component";
import { BenefitSection } from "../components/freelancing-guide/benefit-section.component";
import { ChallengeSection } from "../components/freelancing-guide/challenge-section.component";
import { FreelancingGuideHeader } from "../components/freelancing-guide/freelancing-guide-header.component";
import GuideIntro from "../components/freelancing-guide/guide-intro.component";
import Header from "../components/header.component";
import FreelancerGetStartedSection from "../components/freelancing-guide/Freelance-get-started-section.component";
import { TipSection } from "../components/freelancing-guide/tip-section.component";
import ManageSection from "../components/freelancing-guide/manage-section.component";
import FreelancerCtaSection from "../components/freelancer-call-to-action";
import { useTranslation } from "react-i18next";
import { InvozioAsFreelancer } from "../components/images/png/icons";
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from "../../common/FunctionUtils";
import SEOMetadataComponent from '../components/seo-metadata.component';
const FreelancingGuide = () => {
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
  const canonicalUrl = isEnglish
    ? `https://www.invozio.com/freelance-freelancing?lang=${LOCALES.EN_US}`
    : `https://www.invozio.com/frilans-frilansarbete?lang=${LOCALES.SV_SE}`;


  const schemaMarkup = getSchemaMarkup("frilans-frilansarbete");

  return (
    <>
      <Header />
      <SEOMetadataComponent
        title={t('LET_INVOZIO_HELP_YOU_AS_FREELANCER')}
        // description={t('FEATURES_MAIN_DESCRIPTION')}
        canonicalUrl={canonicalUrl}
        noindex={false}
        robots="index, follow"
        schemaMarkup={schemaMarkup}
      />
      <FreelancingGuideHeader />
      <GuideIntro />
      <BenefitSection />
      <ChallengeSection />
      <FreelancerGetStartedSection />
      <ManageSection />
      <TipSection />
      <FreelancerCtaSection
        title={t('LET_INVOZIO_HELP_YOU_AS_FREELANCER')}
        description={[t('FREELANCING_REWARDING_CAREER_TEXT_1'), t('FREELANCING_REWARDING_CAREER_TEXT_2')]}
        buttonText={t('CREATE_FREE_ACCOUNT')}
        imageSrc={InvozioAsFreelancer}
        imageAlt="Freelancer illustration"
      />
      <div className="bg-footer">
        <Footer />
      </div>
    </>
  );
};

export default FreelancingGuide;
